import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { HighCommissionBoosting } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: HighCommissionBoosting.NAME,
        oldNameMatcher: /^plp_hc_boosting/m,
      },
    ],
  });
};
